import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import HomeView from '@/views/HomeView.vue';
export default {
  __name: 'App',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(HomeView), _createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_Transition, {
          name: "fade"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
          _: 2
        }, 1024)]),
        _: 1
      })], 64);
    };
  }
};